import useStyles from "isomorphic-style-loader/useStyles";
import React, { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useSelector, useStore } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Header from "../../../../components/header";
import { Iconfont } from "../../../../components/icon/iconfont";
import { zendeskClick, zendeskInit } from "../../components/sdk-init";
import classes from './style.module.scss';


const ContactUs = props => {
    useStyles(classes)
    const history = useHistory()
    const Intl = useIntl()
    const store = useStore()
    const {pathname} = useLocation()
    const { customer } = useSelector(state => state.pageCustomer);
    const global = useSelector((state) => state.global);
    const [showVip, setShowVip] = useState(false)

    useEffect(async () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        // document.body.style.background = "#f6f6f6"
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            if(!customer){
                await ContactUs.fetchData(store, null, null)
            }
		}
        return (() => {
            // document.body.style.background = ''
        })
    }, [])

    useEffect(() => {
        if(customer?.id && global?.config?.support){
            const dom = document.getElementById("ze-snippet")
            if(dom){
                zendeskInit(customer, global)
                if(window.zE){
                    window.zE('webWidget', 'hide');
                }
            } else {
                window.zendeskInitWin = () => {
                    zendeskInit(customer, global)
                    if(window.zE){
                        window.zE('webWidget', 'hide');
                    }
                }
                const head = document.getElementsByTagName('head')[0]
                const script = document.createElement('script')
                script.type = 'text/javascript'
                script.id = 'zendesk-sdk'
                script.text = `
                        (function (d, s, id) {
                            var js, fjs = d.getElementsByTagName(s)[0];
                            if (d.getElementById(id)) { return; }
                            js = d.createElement(s); js.id = id;
                            js.async=true;
                            js.onload = window.zendeskInitWin
                            js.src = "https://static.zdassets.com/ekr/snippet.js?key=${global?.config?.support?.zendesk}";
                            fjs.parentNode.insertBefore(js, fjs);
                        }(document, 'script', 'ze-snippet'));
                `
                head.appendChild(script)
            }
        }
    }, [customer, global])

    useEffect(() => {
        if(pathname.indexOf("ticketvip") != -1){
            setShowVip(true)
        }
    }, [pathname])

    return (
        <div className={classes.ContactUs}>
            <Header
                centerSlot={
                    showVip ?
                    <span style={{color: '#DDC35E'}}>
                        <Iconfont style={{marginRight: 5}}>&#xe783;</Iconfont>
                        {Intl.formatMessage({ id: "vip_service", defaultMessage: "VIP-Service" })}
                    </span>:
                    Intl.formatMessage({ id: "contact_us", defaultMessage: "Contact Us" })
                }/>
            <div className={classes.EntryItem} onClick={()=> history.push(`/user/support/ticket`)}>
                <Iconfont className={classes.EntryIcon}>&#xe69c;</Iconfont>
                <div className={classes.EntryInfoBox}>
                    <span>{Intl.formatMessage({id: 'ticket'})}</span>
                    <div className={classes.SupportTime}>{Intl.formatMessage({id: 'ticket_time'})}</div>
                </div>
                <Iconfont className={classes.LinkTo}>&#xe690;</Iconfont>
            </div>
            <div className={classes.EntryItem} id="comm100-button-176-react" onClick={() => zendeskClick()}>
                <Iconfont className={classes.EntryIcon}>&#xe770;</Iconfont>
                <div className={classes.EntryInfoBox}>
                    <span>{Intl.formatMessage({id: 'online_help'})}</span>
                    <div className={classes.SupportTime}>{Intl.formatMessage({id: 'online_time'})}</div>
                </div>
                <Iconfont className={classes.LinkTo}>&#xe690;</Iconfont>
            </div>
        </div>
    )
}

ContactUs.fetchData = async (store, params, search, headers) => {
}

export default ContactUs